import { createContext } from 'react';

export interface SoundContextValue {
  soundDisabled: boolean;
  setSoundDisabled: (value: boolean) => void;
}

export const SoundContext = createContext<SoundContextValue | null>(null);
